import { FormEvent, useContext, useState, type FC } from "react";
import { Button, Form, Input } from "rsuite";
import { LoadingContext } from "../contexts/LoadingContext";
import Loading from "../components/Loading";
import { getProfileByToken, postLogin } from "../services/AuthApi";
import { errorToast } from "../utils/helper-ui";
import { asyncLocalStorage } from "../utils/storage";
import { PERMISSIONS, PROFILE, ROLE_NAME, TOKEN } from "../objects/constants";
import { Permission } from "../models/system/role";
import { PermissionsContext } from "../contexts/PermissionsContext";

interface LoginPageProps {}

const LoginPage: FC<LoginPageProps> = ({}) => {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { permissions, setPermissions } = useContext(PermissionsContext);

  const onSubmit = async (
    formValue: object | null,
    event?: FormEvent<HTMLFormElement>
  ) => {
    try {
      event?.preventDefault();
      setIsLoading(true);
      // console.log(email, password);
      const res = await postLogin(email, password);
      const data = await res.json();
      await asyncLocalStorage.setItem(TOKEN, data.token);
      let profile = await getProfileByToken(data.token);
      let profileJson = await profile.json();
      let {full_name, email : email2, profile_picture} = profileJson.data
      await asyncLocalStorage.setItem(PROFILE, JSON.stringify({full_name, email: email2, profile_picture}));
      if (profileJson.data.roles.length > 0) {
        asyncLocalStorage.setItem(ROLE_NAME, profileJson.data.roles[0].name);
        asyncLocalStorage.setItem(
          PERMISSIONS,
          JSON.stringify(
            profileJson.data.roles[0].permissions.map((p: Permission) => p.name)
          )
        );
        setPermissions(
          profileJson.data.roles[0].permissions.map((p: Permission) => p.name)
        );
      }
      // window.location.href = "/";
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center gradient-violet">
      <div className="bg-white p-10 rounded-2xl shadow-sm w-96">
        <div className="flex items-center justify-center mb-8">
          <img
            src="/images/logo-toko21.png"
            alt=""
            style={{ width: "100px" }}
          />
        </div>
        {isLoading && <Loading />}
        <Form onSubmit={onSubmit}>
          <label className="block mb-4">
            <span className="text-gray-700 font-semibold">Email</span>
            <Input
              type="email"
              placeholder="Enter your email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e)}
            />
          </label>
          <label className="block mb-4">
            <span className="text-gray-700 font-semibold">Password</span>
            <Input
              type="password"
              placeholder="Enter your password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e)}
            />
          </label>
          <Button loading={isLoading} type="submit" appearance="primary" color="violet" block>
            Login
          </Button>
        </Form>
      </div>
    </div>
  );
};
export default LoginPage;
